export default __webpack_public_path__ + "css-3-logo.png";